const mediaItems = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20video%20player%20interface%20elements%20with%20play%20button%2C%20warm%20coral%20accents%2C%20mysterious%20dark%20atmosphere%2C%20editorial%20style&width=600&height=340&seq=media-01-2026&orientation=landscape',
    title: '独家专访：前娱乐记者揭秘狗仔队的日常工作与行业内幕',
    duration: '18:24',
    source: '51吃瓜',
    date: '2026.07.29',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20podcast%20studio%20elements%20collage%2C%20warm%20amber%20lighting%2C%20audio%20waveform%20visual%2C%20editorial%20magazine%20style%2C%20dark%20background&width=600&height=340&seq=media-02-2026&orientation=landscape',
    title: '音频深扒：顶流塌房时间线全梳理，从蛛丝马迹到实锤落地',
    duration: '32:10',
    source: '17c吃瓜',
    date: '2026.07.28',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20graphic%20novel%20style%20entertainment%20scene%2C%20warm%20coral%20tones%2C%20dramatic%20storytelling%2C%20editorial%20illustration%2C%20dark%20atmosphere&width=600&height=340&seq=media-03-2026&orientation=landscape',
    title: '图解爆料：娱乐圈资本版图大起底，谁在幕后操控舆论',
    duration: '图文',
    source: '编辑团队',
    date: '2026.07.27',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20fragments%20collage%2C%20warm%20golden%20spotlight%2C%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background&width=600&height=340&seq=media-04-2026&orientation=landscape',
    title: '现场直击：某综艺录制现场冲突事件的多角度还原与分析',
    duration: '22:45',
    source: '51吃瓜',
    date: '2026.07.26',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20infographic%20style%20collage%2C%20warm%20coral%20and%20amber%20accents%2C%20data%20visualization%2C%20editorial%20design%2C%20dark%20moody%20background&width=600&height=340&seq=media-05-2026&orientation=landscape',
    title: '数据解析：2026上半年明星翻车统计，谁是最强塌房王',
    duration: '15:08',
    source: '17c吃瓜',
    date: '2026.07.25',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">独家视界</h2>
          <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">视频·音频·图解</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">多维度深度报道，视频专访、音频解析与图解爆料，让吃瓜更立体</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative w-full overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-video'}`}>
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl md:text-3xl text-foreground-900 group-hover:text-white ml-1"></i>
                  </div>
                </div>
                {item.duration && (
                  <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
                    {item.duration}
                  </div>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-3">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.source}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}